import Vue from 'vue'
import { BootstrapVue } from 'bootstrap-vue'

// Import Bootstrap an BootstrapVue CSS files (order is important)
import 'bootstrap/dist/css/bootstrap-utilities.min.css'
import 'bootstrap-vue/dist/bootstrap-vue.min.css'

// Make BootstrapVue available throughout your project
Vue.use(BootstrapVue)
